<template>
  <div class="px-4 d-flex flex-row align-center" v-if="profileStore && profileStore.profile" style="width: 100%; height: 100%;">
    <!-- Left: Page title -->
    <div class="d-flex align-center gap-3">
      <v-img height="32" width="32" :src="require('@/assets/images/Logo.svg')" v-if="!$vuetify.display.mdAndUp" />
      <div>
        <div class="header-page-title">{{ $route.meta.title || 'Dashboard' }}</div>
        <div class="header-breadcrumb" v-if="$vuetify.display.mdAndUp">My First Business
          <span class="mx-1 text-disabled">·</span>
          <v-chip size="x-small" :color="realeaseData.color" v-if="realeaseData.display">{{ realeaseData.text }}</v-chip>
          <span v-else class="text-disabled text-caption">v{{ version }}</span>
        </div>
      </div>
    </div>

    <v-spacer />

    <!-- Center: Countdown -->
    <div class="d-flex flex-column align-center" v-if="currentCountdown">
      <div class="header-countdown-name text-primary">{{ currentCountdown.name }}</div>
      <div class="header-countdown-time text-medium-emphasis">{{ currentTime }}</div>
    </div>

    <v-spacer />

    <!-- Right: Alerts and user info -->
    <div class="d-flex flex-row align-center gap-3">
      <AlertsMenu />
      <div class="d-flex flex-column align-right" v-if="$vuetify.display.smAndUp">
        <span class="header-user-name text-accent">{{ profileStore.profile.firstname }} {{ profileStore.profile.lastname }}</span>
        <span class="header-user-role text-medium-emphasis">{{ profileStore.profile.role }}</span>
      </div>
      <Avatar :profile="profileStore.profile" size="36" badge />
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import { useProfileStore } from '@/stores/profile'
import { useAppStore } from '@/stores/appdata.js'
import packageJSON from '@/../package.json'

import Avatar from '@/components/users/Avatar.vue'
import TeamLogo from '@/components/TeamLogo.vue'
import AlertsMenu from '@/components/common/AlertsMenu.vue'

export default {
  components: { Avatar, TeamLogo, AlertsMenu },
  data: () => ({
    profileStore: useProfileStore(),
    appStore: useAppStore(),
    version: packageJSON.version,
    realeaseData: packageJSON.realeaseData,

    now: new Date(),
    interval: undefined
  }),
  created() {
    clearInterval(this.interval)

    const tmp = new Date(this.now)
    tmp.setMilliseconds(0)
    tmp.setSeconds(0)
    tmp.setMinutes(this.now.getMinutes() + 1)
    const timeBeforeNextMinutes = tmp.getTime() - this.now.getTime()

    setTimeout(() => {
      this.interval = setInterval(() => {
        this.now = new Date()
      }, 1000 * 60)
    }, timeBeforeNextMinutes)
  },
  computed: {
    currentCountdown() {
      if (this.appStore.appdata.parameters.countdowns && this.appStore.appdata.parameters.countdowns.filter(c => c.enabled).length > 0) {
        return this.appStore.appdata.parameters.countdowns.filter(c => c.enabled)[0]
      }
    },
    currentTime() {
      if (this.currentCountdown) {
        let prefix = moment(this.now).diff(moment(new Date(this.currentCountdown.anchor))) > 0 ? 'Il y a ' : 'Dans '

        let duration = moment.duration(Math.abs(moment(this.now).diff(moment(new Date(this.currentCountdown.anchor)))))
        let days = duration.days().toFixed(0)
        let hours = duration.hours().toFixed(0)
        let minutes = duration.minutes()

        let timeStr = prefix 
        
        if(days > 0) timeStr += days + " jours "
        if(days > 0 || hours > 0) timeStr += hours.toString().padStart(2, '0') + ' h '
        if(days > 0 || hours > 0 || minutes > 0) timeStr += minutes.toString().padStart(2, '0') + ' min'

        return timeStr
      }
    }
  }
}

</script>

<style scoped>
.header-page-title {
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 1.2;
  color: rgb(var(--v-theme-primary));
}
.header-breadcrumb {
  font-size: 0.7rem;
  color: rgba(255,255,255,0.35);
  letter-spacing: 0.04em;
  margin-top: 1px;
}
.header-countdown-name {
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 1.2;
}
.header-countdown-time {
  font-size: 0.7rem;
  letter-spacing: 0.04em;
}
.header-user-name {
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.2;
  text-align: right;
}
.header-user-role {
  font-size: 0.65rem;
  text-align: right;
  letter-spacing: 0.04em;
}
</style>